<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="main">
      <g id="icon">
        <path
          d="M7.163,5.115L6.99,5.404L7.039,5.737L7.288,5.963L7.48,6.002L11.52,6.002L11.84,5.888L12.01,5.6L11.96,5.267L11.71,5.04L11.52,5.002L7.48,5.002zz"
          fill="currentColor"
        />
        <path
          d="M3.242,5.01L3.006,5.053L2.839,5.116L2.642,5.234L2.506,5.352L2.365,5.529L2.278,5.697L2.212,5.918L2.193,6.013L1.048,17.78L1.05,17.89L1.082,18.14L1.153,18.35L1.286,18.56L1.425,18.71L1.636,18.86L1.821,18.94L2.086,18.99L2.187,19L12.02,19L11.48,18.55L11.02,18L2.238,18L2.123,17.98L2.082,17.95L2.061,17.91L2.049,17.82L3.184,6.159L3.208,6.076L3.233,6.045L3.275,6.02L3.377,6.002L4.326,6.002L4.643,5.888L4.816,5.6L4.767,5.267L4.518,5.04L4.326,5.002L3.332,5.002zM14.26,5.115L14.09,5.404L14.14,5.737L14.39,5.963L14.58,6.002L15.67,6.002L15.77,6.021L15.81,6.045L15.83,6.076L15.86,6.159L16.25,10.17L16.97,10.39L17.29,10.57L16.85,6.013L16.83,5.918L16.76,5.697L16.68,5.529L16.54,5.352L16.4,5.234L16.2,5.116L16.04,5.053L15.8,5.01L15.71,5.002L14.58,5.002zz"
          fill="currentColor"
        />
        <path
          d="M5.167,6.845L4.885,7.028L4.695,7.298L4.626,7.629L4.695,7.961L4.885,8.231L5.167,8.413L5.513,8.48L5.858,8.413L6.14,8.231L6.33,7.961L6.4,7.629L6.33,7.298L6.14,7.028L5.858,6.845L5.513,6.778zz"
          id="b"
          fill-rule="evenodd"
          fill="#FFFFFF"
        />
        <path
          d="M13.11,6.845L12.82,7.028L12.63,7.298L12.56,7.629L12.63,7.961L12.82,8.231L13.11,8.413L13.45,8.48L13.8,8.413L14.08,8.231L14.27,7.961L14.34,7.629L14.27,7.298L14.08,7.028L13.8,6.845L13.45,6.778zz"
          id="b"
          fill-rule="evenodd"
          fill="#FFFFFF"
        />
        <path
          d="M8.879,0.2084L8.779,0.2285L8.284,0.3822L8.19,0.4225L7.75,0.6664L7.672,0.7199L7.284,1.044L7.226,1.101L6.884,1.496L6.844,1.55L6.546,2.005L6.519,2.052L6.26,2.558L6.243,2.597L6.019,3.145L6.004,3.189L5.648,4.367L5.637,4.407L5.376,5.631L5.371,5.656L5.008,7.923L5.07,8.254L5.328,8.47L5.664,8.475L5.928,8.265L5.996,8.081L6.357,5.824L6.611,4.636L6.954,3.501L7.16,2.995L7.398,2.53L7.663,2.124L7.955,1.787L8.276,1.518L8.63,1.322L9.027,1.199L9.481,1.155L9.936,1.199L10.33,1.322L10.69,1.518L11.01,1.787L11.3,2.125L11.57,2.53L11.8,2.993L12.01,3.5L12.35,4.636L12.61,5.827L12.97,8.081L13.13,8.376L13.44,8.501L13.76,8.4L13.95,8.119L13.95,7.923L13.59,5.656L13.59,5.631L13.33,4.407L13.32,4.367L12.96,3.189L12.94,3.145L12.72,2.597L12.7,2.558L12.44,2.052L12.42,2.005L12.12,1.55L12.08,1.496L11.74,1.101L11.68,1.044L11.29,0.7199L11.21,0.6664L10.77,0.4225L10.68,0.3822L10.18,0.2285L10.08,0.2084L9.529,0.1549L9.433,0.1549zz"
          fill="currentColor"
        />
        <path
          d="M5.111,7.079L4.793,7.293L4.579,7.611L4.5,8L4.579,8.389L4.793,8.707L5.111,8.921L5.5,9L5.889,8.921L6.207,8.707L6.421,8.389L6.5,8L6.421,7.611L6.207,7.293L5.889,7.079L5.5,7zz"
          fill="currentColor"
        />
        <path
          d="M13.11,7.079L12.79,7.293L12.58,7.611L12.5,8L12.58,8.389L12.79,8.707L13.11,8.921L13.5,9L13.89,8.921L14.21,8.707L14.42,8.389L14.5,8L14.42,7.611L14.21,7.293L13.89,7.079L13.5,7zz"
          fill="currentColor"
        />
      </g>
      <g id="overlay">
        <path
          d="M18.1234,16.9342l2.3292,2.3292c0.1965,0.1965,0.1965,0.518,0,0.7145l-0.4576,0.4576c-0.1965,0.1965,-0.518,0.1965,-0.7145,0l-2.4452,-2.3452"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
        <circle
          cx="15.0232"
          cy="15.0117"
          r="3.5117"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
